import React, { useContext } from 'react';
import { Box, Typography, FormControlLabel } from '@mui/material';
import { assign } from 'xstate';
import { cloneDeep } from 'lodash';
import { IntlShape } from 'react-intl';

import { SendContext } from '../../SendContext';
import { MachineContext } from '../../MachineContext';
import { BaseComponent } from '../Component';
import { translateWithFallback } from '../../util';

import styles from './SelectionCard.module.css';

export interface SelectionCardComponent extends BaseComponent {
  type: 'selectionCard';
  props: SelectionCardProps;
}
export interface SelectionCardProps {
  buttonTexts: string[];
  keyTexts: string[];
  saveResultTo: string;
  width?: number;
  displayInColums?: boolean;
  keyNumbers?: number[];
}
export const SelectionCard: React.FC<SelectionCardProps> = ({
  buttonTexts,
  keyTexts,
  saveResultTo,
  width,
  displayInColums = false,
  keyNumbers = [],
}) => {
  const { send } = useContext(SendContext);
  const spaceBetweenFlexing: any = {
    display: 'flex',
    alignItems: 'flex-end',
    flexDirection: 'row',
    gap: '1em',
    width: width ? width + 'px' : '500px',
    flexWrap: 'wrap',
  };
  const columnFlexing: any = {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr 1fr',
    width: width ? width : '500px',
    gridAutoRows: '1fr',
    gridColumnGap: '10px',
    gridRowGap: '10px',
  };
  const buttonColumnStyle: any = {
    height: '100%',
    width: '100%',
  };
  const buttonFlexStyle: any = {
    height: '100%',
  };
  return (
    <div style={{ marginLeft: '15px' }}>
      <Box sx={displayInColums ? columnFlexing : spaceBetweenFlexing}>
        {buttonTexts.map((buttonText, index) => {
          return (
            <FormControlLabel
              control={
                <div
                  className={styles['selection-button']}
                  style={displayInColums ? buttonColumnStyle : buttonFlexStyle}
                  onClick={() => {
                    send({
                      type: 'writeToContext',
                      payload: { [saveResultTo]: buttonText },
                    });
                    send({
                      type: 'writeToContext',
                      payload: {
                        [saveResultTo + '_NUM']:
                          keyNumbers !== undefined &&
                          keyNumbers !== null &&
                          Array.isArray(keyNumbers) &&
                          keyNumbers.length > 0
                            ? keyNumbers[index]
                            : index,
                      },
                    });
                    send({ type: keyTexts[index] });
                  }}
                >
                  <Typography align="center">{buttonText}</Typography>
                </div>
              }
              label=""
              value={'selectioncard' + index}
              key={buttonText.length + '_' + index + '_labelid'}
            />
          );
        })}
      </Box>
    </div>
  );
};

export const renderSelectionCardAction = (intl: IntlShape) => {
  return assign((context: MachineContext, _event, actionMetadata) => {
    const newContext = cloneDeep(context);
    newContext.widgetData = newContext.widgetData.filter(
      (element) => !element.temporary
    );
    const payload = actionMetadata.action.payload;
    const buttonTexts: string[] = payload.buttonTexts.map((button: string) =>
      translateWithFallback(intl, button)
    );
    const keyTexts = payload.keyTexts;
    newContext.widgetData.push({
      type: 'selectionCard',
      temporary: actionMetadata.action.temporary ?? false,
      props: {
        buttonTexts: buttonTexts,
        keyTexts:
          keyTexts &&
          Array.isArray(keyTexts) &&
          keyTexts.length === payload.buttonTexts.length
            ? keyTexts
            : payload.buttonTexts,
        saveResultTo: payload.saveResultTo,
        width: payload.width,
        displayInColums: payload.displayInColums,
        keyNumbers: payload.keyNumbers,
      },
    });
    return newContext;
  });
};
